var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalPrioritize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.90234,
    width: 1.29288,
    height: 12,
    rx: 0.646438,
    fill: "#798B99"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 1.29288,
    height: 6,
    rx: 0.646438,
    fill: "#798B99"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.70703,
    y: 3,
    width: 1.29288,
    height: 6,
    rx: 0.646438,
    fill: "#798B99"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.80469,
    width: 1.29288,
    height: 12,
    rx: 0.646438,
    fill: "#798B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalPrioritize);
export default __webpack_public_path__ + "static/media/vertical_prioritize.9a147593ea69334f392557bf5eefe966.svg";
export { ForwardRef as ReactComponent };